import React from 'react'
import { Box, Container } from "@mui/material";
import AutomationTable from '../components/AutomationTable';

function ConfiguredDevices(props) {
    return (
        <Container maxWidth={false}>
            <Box mt={5} justifyContent='center'>
                <AutomationTable />
            </Box>
        </Container>
    )
}

export default ConfiguredDevices